import { fetchAsObservable } from 'fetcher!sofe';
import canopyUrls from 'canopy-urls!sofe';

export function getCanopyPaymentsStatus() {
  return fetchAsObservable(`${canopyUrls.getWorkflowUrl()}/api/canopy_payments/status`);
}
